<template>
  <div class="templateSetting">
    <!-- 修改合同模板弹窗-->
    <el-dialog
      title="设置保留位数"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form label-width="120px" ref="deptForm">
        <el-row>
          <el-col :span="22">
            <el-form-item label="裸税合价">
              <el-radio-group v-model="decimalForm.totalPurePrice">
                <el-radio
                  v-for="item in list"
                  :label="item.value"
                  :key="item.value"
                  style="width: 100px; margin: 10px 0"
                >{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="税后合价" v-if="type!='MATERIAL'">
              <el-radio-group v-model="decimalForm.totalPriceAfterTax">
                <el-radio
                  v-for="item in list"
                  :label="item.value"
                  :key="item.value"
                  style="width: 100px; margin: 10px 0"
                >{{ item.name }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="saveDecimalClick()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "templateSetting",
  props: {
    decimalVO: {
      type: Object,
    },
  },
  data() {
    return {
      isDialogShow: false,
      type:'',
      decimalForm: {
          totalPurePrice:2,
          totalPriceAfterTax:2
        }, //设置字段小数位数,
      // list: [],
      list: [{ name: "保留两位", value: 2 },{ name: "保留一位", value: 1},{ name: "整数", value: 0}],
    };
  },
  created() {
    //获取项目部
    // this.getDept();
  },
  methods: {
    showDialog(type,decimalVO) {
      this.type=type
      // switch (type) {
      //   case "LABOR":
      //     this.list = this.laborlist;
      //     break;
      //   case "MATERIAL":
      //     this.list = this.materiallist;
      //     break;
      //   case "MACHINE":
      //     this.list = this.machinelist;
      //     break;
      //   case "OTHERS":
      //     this.list = this.otherslist;
      //     break;
      //   default:
      //     break;
      // }
      this.decimalForm={...decimalVO}
      this.isDialogShow = true;
    },
    saveDecimalClick() {
      this.$message.success("已设置保留位数");
      this.isDialogShow = false;
      this.$emit("saveDecimalFun", this.decimalForm);
    },
  },
};
</script>

<style scoped lang="scss">
.templateSetting {
  /deep/.el-dialog {
    /deep/.el-icon-view:before {
      display: none;
    }
  }
  /deep/.el-select {
    width: 100%;
  }
}
</style>
